module.exports = __webpack_public_path__ + "media/images/icons/volume-high-0bd9abcdced8835dc4f803af3a6f9a7f.svg";